import { withChartLayout } from 'components/common';
import AdolescentRiskAssessment from 'components/features/chart/admission-history/adolescent-risk-assessment/AdolescentRiskAssessment';

const AdolescentRiskAssessmentPage = withChartLayout('Adolescent Risk Assessment')(AdolescentRiskAssessment);
export default AdolescentRiskAssessmentPage;
